import { render, staticRenderFns } from "./onecenterMenu.vue?vue&type=template&id=16784638&scoped=true&"
import script from "./onecenterMenu.vue?vue&type=script&lang=js&"
export * from "./onecenterMenu.vue?vue&type=script&lang=js&"
import style0 from "./onecenterMenu.vue?vue&type=style&index=0&id=16784638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16784638",
  null
  
)

export default component.exports